<div class="create-project-header twc-col-lg-6 twc-col-md-12 twc-mb-4">
    <div class="twc-message-box">{{ 'JOB_SITE.GENERAL.VERSION_DISCLAIMER' | translate}}</div>
</div>

<form [formGroup]="createSiteForm" class="twc-form">
    <div class="twc-form-control twc-col-lg-6 twc-col-md-12">
        <label for="name" class="twc-form-label font-bold">{{ 'JOB_SITE.CREATE.NAME' | translate }}</label>
        <div class="twc-form-element">
            <input id="name" formControlName="name" class="twc-input" required [maxLength]="defaultMaxLength"
                placeholder="{{'JOB_SITE.CREATE.PLACEHOLDER_NAME' | translate}}">
        </div>
    </div>
    <div class="twc-form-control twc-col-lg-6 twc-col-md-12">
        <label for="description" class="twc-form-label font-bold">
            {{ 'JOB_SITE.CREATE.DESCRIPTION' | translate }}
        </label>
        <div class="twc-form-element">
            <textarea id="create-site-description" formControlName="description"
                class="twc-textarea create-site-description" [maxLength]="defaultMaxLength"
                placeholder="{{'JOB_SITE.CREATE.PLACEHOLDER_DESCRIPTION' | translate}}">
            </textarea>
        </div>
    </div>
    <div class="twc-form-control twc-col-lg-6 twc-col-md-12">
        <label for="projection" class="twc-form-label font-bold">{{ 'CREATE_PROJECT.COORDINATE' | translate
            }}</label>
        <div class="twc-form-element">
            <cw-crs-search placeholder="{{'CREATE_PROJECT.PLACEHOLDER_COORDINATE' | translate}}" type="crs"
            [selectItem]="createSiteForm.controls.horizProjectionEPSG.value"
            (selectItemChange)="setSelectedCRS($event)"></cw-crs-search>
        </div>
    </div>

    <div class="twc-form-control twc-col-lg-6 twc-col-md-12">
        <label for="groundSampleDistance" class="twc-form-label font-bold">
            {{'JOB_SITE.CREATE.DATA_TYPE' | translate}}
        </label>
        <div class="twc-radio twc-radio-inline">
            <input class="twc-radio-input" type="radio" id="ground-surface" formControlName="snapshotType"
                [value]="'Ground surface'">
            <label class="twc-radio-label" for="ground-surface">{{'JOB_SITE.CREATE.GROUND_SURFACE'|
                translate}}</label>
        </div>
        <div class="twc-radio twc-radio-inline">
            <input class="twc-radio-input" type="radio" id="3d-object" formControlName="snapshotType"
                [value]="'3D objects'">
            <label class="twc-radio-label" for="3d-object">{{'JOB_SITE.CREATE.3D_OBJECT'| translate}}</label>
        </div>
    </div>

    <div class="twc-form-control twc-col-lg-6 twc-col-md-12">
        <label for="groundSampleDistance" class="twc-form-label font-bold">{{ 'JOB_SITE.CREATE.DISTANCE' | translate
            }}</label>
        <div class="twc-form-element">
            <input id="create-distance" formControlName="sampleDistance" class="twc-input" required type="number"
                cwNumberDecimals>
        </div>
    </div>

    <!-- TODO: Workaround until TWC fixed the disabled property -->
    <button class="twc-button twc-button-primary twc-mt-5" type="button" [twcLoading]="loading"
        [attr.disabled]="!createSiteForm.valid || null" (click)="onCreateSite()">
        <span> {{'JOB_SITE.CREATE.TITLE' | translate}} </span>
    </button>
</form>